import { defineTranslations } from '@/hooks/use-component-translation/utils'

import deDe from './deDe.json'
import enUs from './enUs.json'
import esEs from './esEs.json'
import frFr from './frFr.json'
import itIt from './itIt.json'
import ptBr from './ptBr.json'

export default defineTranslations(import.meta.url, {
  enUs,
  ptBr,
  esEs,
  frFr,
  deDe,
  itIt,
})
